export default class RequestQueue {
  constructor() {
    this.queue = [];      // 存储请求的队列
    this.isProcessing = false;
    // 绑定方法确保 `this` 指向正确
    this.processQueue = this.processQueue.bind(this);
  }

  // 添加请求到队列
  addRequest(requestFn) {
    this.queue.push(requestFn);
    if (!this.isProcessing) {
      this.processQueue();
    }
  }

  // 处理队列（修复版）
  async processQueue() {
    if (this.queue.length === 0) {
      this.isProcessing = false;
      return;
    }
    this.isProcessing = true;
    const requestFn = this.queue.shift(); // 取出第一个请求
    try {
      await requestFn(); // 执行请求
    } catch (error) {
      console.error("请求失败:", error);
    }
    // 等待 500ms 后继续处理下一个请求
    await new Promise(resolve => setTimeout(resolve, 500));
    // 递归调用以处理后续请求
    this.processQueue();
  }
}